import api from '../../shared/services/api'

export const fetchQuestionnaireData = async (endpoint, endpointParams) => {
    const commentResponse = await api.post(endpoint, endpointParams)
    return commentResponse.data
}